import { ComponentProps } from 'react';
import { ServiceUsage } from '~/types/model/serviceUsage';
import { convertDateTime } from '~/utils/dateTime';
import { ServiceReportPresentation } from '../../presentations';

type IConvertToServiceUsageDisplayType = (
  serviceUsage: ServiceUsage,
  index: number
) => ComponentProps<typeof ServiceReportPresentation>['filteredServiceApplications'][number];

export const convertToServiceUsageDisplayType: IConvertToServiceUsageDisplayType = (
  serviceUsage,
  index
): ComponentProps<typeof ServiceReportPresentation>['filteredServiceApplications'][number] => ({
  no: index + 1,
  service_title: serviceUsage.service?.title || '',
  user_name: serviceUsage.user?.full_name || '',
  create_at: convertDateTime(serviceUsage.created_at),
});
